<template>
  <div id="report">
    <div class="full-overlay">
      <div class="overlay-header">
        <b-container fluid>
          <b-row align-h="center" align-v="center" class="my-md-4">
            <b-col>
            </b-col>
            <b-col cols="7">
              <div class="overlay-subnav text-center" v-if="$route.name != 'Results'" >
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) === 0" variant="link"  :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)-1]"><icon scale="2" name="angle-left"/></b-button>
                <span class="subnav-progress">
                  <router-link class="item" :key="index" v-for="(report, index) in $parent.availableReports" :class="{'active': report === $parent.openedReport}" :to="report"></router-link>
                </span>
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) >= $parent.availableReports.length -1" variant="link" :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)+1]"><icon scale="2" name="angle-right"/></b-button>
              </div>
            </b-col>
            <b-col class="text-right">
              <b-button class="icon--color" variant="link" to="/personal/results" id="close-button"><icon name="times" scale="2"/></b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="overlay-content">
        <b-container fluid class="px-0 pt-0 pb-4">
          <b-row align-v="center" align-h="center" class="py-4 mb-5 card--text">
            <b-col cols="12" sm="12" md="10" class="text-center p-3">
              <h1 class="info-headline">{{$t('personal-results:title-uwes')}}</h1>
              <h5><span>{{ $t('personal-results:description-uwes') }}</span></h5>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid class="pt-0 pb-3">
          <div v-if="$parent.currentEngagementReport.stats">
            <b-row align-v="center" align-h="center" class="mt-2">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <b-row>
                  <b-col>
                    <div class="overall-score">
                      <span class="--value">{{$parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-total'].avg/6.0*100)}}</span>
                      <span class="--scale">/ 100</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="animated-bar">
                      <div class="meter" :class="{'activated': $parent.personalUWESPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentEngagementReport.stats['uwes9-total'].class), 'width': $parent.personalUWESPercent}"></div>
                    </div>
                    <p class="tidbit">{{$t('common:updated')}} {{$parent.currentEngagementReport.updatedAt | moment('from')}}.</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title">
                  <span>{{ $t('personal-results:total-classification-title-' + $parent.currentEngagementReport.categories['uwes9-total']) }}</span>
                </h3>
                <p><b-btn v-b-toggle.collapse1 variant="link" size="sm"><icon name="regular/lightbulb" style="margin-right: 0.5em;"/> {{$t('common:what-is-work-engagement')}}</b-btn></p>
              </b-col>
            </b-row>
            <b-row align-v="center" align-h="center">
              <b-col cols="12" md="12">
                <div>
                  <b-collapse id="collapse1" class="mt-0">
                    <b-card>
                      <p>{{$t('common:description-personal-work-engagement')}}</p>
                    </b-card>
                  </b-collapse>
                </div>
              </b-col>
            </b-row>
            <!-- TOTAL CHANGE -->
            <b-row v-if="$parent.uwesTotalChange !== null" align-v="center" align-h="center" class="my-5">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <div class="trend-indicator" :class="{'up': $parent.uwesTotalChange >= 0.77, 'down': $parent.uwesTotalChange <= -0.77, 'flat': Math.abs($parent.uwesTotalChange) < 0.77 }">
                  <icon class="--icon mr-1" style="color: #377771;" v-if="$parent.uwesTotalChange > 0" name="caret-up"/>
                  <icon class="--icon mr-1" style="color: #ed6a5e;" v-if="$parent.uwesTotalChange < 0" name="caret-down"/>
                  <icon class="--icon mr-1" style="color: #377771;" v-if="$parent.uwesTotalChange == 0" name="minus"/>
                  <div class="--magnitude">
                    <span class="--value">{{Math.abs($parent.formatNumber0($parent.uwesTotalChange/6.0*100))}}</span>
                  </div>
                </div>
                <div class="--reference-point">{{$t('personal-results:from')}} {{$parent.formatNumber0($parent.currentEngagementReport.previous.total.avg / 6 * 100)}} / 100 ({{$parent.currentEngagementReport.previous.total.updatedAt | moment('MMMM YYYY')}})</div>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title">
                  <span v-if="$parent.currentDirectionClass !== null">{{ $t('personal-results:total-direction-title-' + $parent.currentDirectionClass) }}</span><span v-if="$parent.uwesTotalChange !== 0 && $parent.currentEngagementReport.categories['uwes9-total'] === $parent.currentEngagementReport.previous.total.class">{{ $t('personal-results:total-class-same-' + $parent.currentEngagementReport.previous.total.class) }}</span>
                  <span v-else-if="$parent.uwesTotalChange > 0 && $parent.currentEngagementReport.categories['uwes9-total'] !== $parent.currentEngagementReport.previous.total.class">
                    {{ $t('personal-results:total-class-level-up-' + $parent.currentEngagementReport.previous.total.class + '--' + $parent.currentEngagementReport.categories['uwes9-total']) }}
                  </span>
                  <span v-else-if="$parent.uwesTotalChange < 0 && $parent.currentEngagementReport.categories['uwes9-total'] !== $parent.currentEngagementReport.previous.total.class">
                    {{ $t('personal-results:total-class-level-down-' + $parent.currentEngagementReport.previous.total.class + '--' + $parent.currentEngagementReport.categories['uwes9-total']) }}
                  </span>
                </h3>
              </b-col>
            </b-row>
            <b-row v-else align-v="center" align-h="center" class="my-3">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <div class="bubble">
                  <div class="message">
                    {{$t('personal-results:promise-engagement-change')}}
                  </div>
                </div>
              </b-col>
            </b-row>
            <!-- <b-row v-else align-v="center" align-h="center" class="my-5">
              <b-col cols="12" sm="12" md="8" lg="8">
                <p style="font-style: italic;">When you have data from a longer time period, you will be able to see here how your wellbeing has developed.</p>
              </b-col>
            </b-row> -->
            <!-- TOTAL COMPARISON -->
            <b-row align-v="center" align-h="center" class="mt-2" v-if="$parent.hasDataForTotalComparison">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <b-row>
                  <b-col cols="12">
                    <div class="overall-score">
                      <span class="--value">{{$parent.formatNumber0($parent.currentCompanyEngagementReport.stats['uwes9-total'].avg/6.0*100)}}</span>
                      <span class="--scale">/ 100</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="animated-bar">
                      <div class="meter" :class="{'activated': $parent.companyUWESPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentCompanyEngagementReport.categories['uwes9-total']), 'width': $parent.companyUWESPercent}"></div>
                    </div>
                    <p class="tidbit">{{$t('personal-results:current-average-of-team', {account: $store.state.account.name})}}, {{$t('common:updated')}} {{$parent.currentCompanyEngagementReport.updatedAt | moment('from')}}.</p>
                  </b-col>
                </b-row>
                <b-button variant="outline-primary" size="sm" class="mb-3" to="/team/reports">{{$t('personal-results:full-team-report-cta')}}</b-button>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title" v-if="$parent.getUWESDifferenceDegree() === 0">{{$t('personal-results:team-comparison-0')}}</h3>
                <h3 class="feedback-title" v-if="$parent.getUWESDifferenceDegree() > 0 && $parent.getPersonalTeamUWESDifference() < 0">{{$t('personal-results:team-comparison-below-' + $parent.getUWESDifferenceDegree())}}</h3>
                <h3 class="feedback-title" v-if="$parent.getUWESDifferenceDegree() > 0 && $parent.getPersonalTeamUWESDifference() > 0">{{$t('personal-results:team-comparison-above-' + $parent.getUWESDifferenceDegree())}}</h3>
                <p><b-btn v-b-toggle.collapse2 variant="link" size="sm"><icon name="regular/lightbulb" style="margin-right: 0.5em;"/> {{$t('common:well-being-not-a-competition')}}</b-btn></p>
              </b-col>
            </b-row>
            <b-row v-else align-v="center" align-h="center" class="my-3">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <div class="bubble">
                  <div class="message">
                    {{$t('personal-results:promise-team-comparison')}}
                  </div>
                </div>
              </b-col>
            </b-row>

            <!-- <b-row v-else align-v="center" align-h="center" class="my-5">
              <b-col cols="12" sm="12" md="6">
                <p style="font-style: italic;">You will see a comparison between you and your team once more than five team members have answered the questionnaire for the first time.</p>
              </b-col>
            </b-row> -->
            <b-row align-v="center" align-h="center" class="mb-3">
              <b-col cols="12" md="12">
                <div>
                  <b-collapse id="collapse2" class="mt-0">
                    <b-card>
                      <p>{{$t('common:description-work-engagement-did-you-know')}}</p>
                    </b-card>
                  </b-collapse>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
      <div class="overlay-footer d-none d-md-block">
        <b-container fluid>
          <b-row align-h="center">
            <b-col class="text-center mt-3 mb-3 my-md-4">
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted: function () {
    this.$parent.openedReport = 'engagement'
  }
}
</script>
